module.exports = __webpack_public_path__ + "static/media/frenchFlag.796eafb8.svg";